import {
  createContext,
  useContext,
  type Dispatch,
  type SetStateAction,
  type MutableRefObject,
} from 'react';
import {
  SynthOIPutCallImpactConfig,
  SynthOIPCImpactDatum,
} from '../../../types';
import { BrushZoomConfig } from '../../../types/shared';

export interface SynthOIPutCallImpactContextValue {
  selectedSym: string;

  config: SynthOIPutCallImpactConfig;
  updateConfig: (patch: Partial<SynthOIPutCallImpactConfig>) => void;

  chartData: SynthOIPCImpactDatum[];
  setChartData: Dispatch<SetStateAction<SynthOIPCImpactDatum[]>>;

  zoomConfig: BrushZoomConfig;
  setZoomConfig: Dispatch<SetStateAction<BrushZoomConfig>>;

  chartRef: MutableRefObject<HTMLDivElement | null>;
}

export const SynthOIPutCallImpactContext =
  createContext<SynthOIPutCallImpactContextValue | null>(null);

export const useSynthOIPutCallImpactCtx = () => {
  const ctx = useContext(SynthOIPutCallImpactContext);
  if (ctx == null) {
    throw new Error(
      'useSynthOIPutCallImpactCtx must be used within a SynthOIPutCallImpactProvider',
    );
  }
  return ctx;
};
